import { render } from "./EditNaikPangkat.vue?vue&type=template&id=520a0174&ts=true"
import script from "./EditNaikPangkat.vue?vue&type=script&lang=ts"
export * from "./EditNaikPangkat.vue?vue&type=script&lang=ts"

import "./EditNaikPangkat.vue?vue&type=style&index=0&id=520a0174&lang=scss"

import exportComponent from "/home/vendor/oesb/ispk-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__